/* eslint-disable react/prop-types */
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/Card";
import { Receipt } from "lucide-react";

const formatTime = (dateString) => {
  return new Date(dateString).toLocaleTimeString("es-ES", {
    hour: "2-digit",
    minute: "2-digit",
  });
};

const PaymentBadge = ({ type }) => (
  <span
    className={`inline-flex px-2 py-1 rounded-full text-xs font-semibold
    ${
      type === "Efectivo"
        ? "bg-green-100 text-green-700"
        : "bg-blue-100 text-blue-700"
    }`}
  >
    {type}
  </span>
);

const OrderItems = ({ items }) => (
  <div>
    {items.map((item, index) => (
      <div key={index} className="flex justify-between">
        <span>
          {item.quantity}x {item.name}
        </span>
        <span className="text-gray-500">${item.price.toFixed(2)}</span>
      </div>
    ))}
  </div>
);

export const SalesTable = ({ sales, metrics }) => {
  return (
    <Card className="border-orange-200">
      <CardHeader className="border-b border-orange-200 bg-orange-500">
        <CardTitle className="text-2xl text-white flex items-center">
          <Receipt className="mr-2 h-6 w-6" />
          Detalle de Ventas
        </CardTitle>
      </CardHeader>
      <CardContent className="p-0">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-orange-50">
              <tr className="border-b border-orange-200">
                <th className="px-4 py-3 text-left text-sm font-medium text-gray-600">
                  Hora
                </th>
                <th className="px-4 py-3 text-left text-sm font-medium text-gray-600">
                  Mesa
                </th>
                <th className="px-4 py-3 text-left text-sm font-medium text-gray-600">
                  Orden
                </th>
                <th className="px-4 py-3 text-left text-sm font-medium text-gray-600">
                  Pago
                </th>
                <th className="px-4 py-3 text-right text-sm font-medium text-gray-600">
                  Total
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-orange-100">
              {sales.transactions.map((transaction) => (
                <tr key={transaction.orderId} className="hover:bg-orange-50">
                  <td className="px-4 py-3 text-sm text-gray-600">
                    {formatTime(transaction.date)}
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-600">
                    {transaction.mesaId}
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-900">
                    <OrderItems items={transaction.items} />
                  </td>
                  <td className="px-4 py-3 text-sm">
                    <PaymentBadge type={transaction.payment} />
                  </td>
                  <td className="px-4 py-3 text-sm text-right font-medium text-gray-900">
                    ${transaction.amount.toFixed(2)}
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot className="bg-orange-50 border-t border-orange-200">
              <tr>
                <td
                  colSpan="4"
                  className="px-4 py-3 text-sm font-medium text-gray-600 text-right"
                >
                  Total del Día:
                </td>
                <td className="px-4 py-3 text-right font-bold text-orange-600">
                  ${metrics?.totalSales.toFixed(2)}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </CardContent>
    </Card>
  );
};
